import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';

// const routes: Routes = [
//   {
//     path:'uima',
//     loadChildren:()=>import('./administrator/administrator.module').then(mod=>mod.AdministratorModule)
//   },
//   {
//     path:'',
//     redirectTo:'uima/login',
//     pathMatch:'full'
//   }
// ];

const routes: Routes = [
  {
    path: 'uima',
    component: LayoutComponent, // Tambahkan LayoutComponent
    children: [
      {
        path: '',
        loadChildren: () => import('./administrator/administrator.module').then(mod => mod.AdministratorModule),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'uima/home',
    pathMatch: 'full',
  },
];

// const routes: Routes = [
//   {
//     path: 'uima',
//     loadChildren: () =>
//       import('./administrator/administrator.module')
//         .then(m => m.AdministratorModule)
//   },
//   {
//     path: '',
//     redirectTo: 'uima/home',
//     pathMatch: 'full'
//   }
// ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
